import * as types from "./constants";

const initialState = {
  elabUser: {},
  elabToken: null,
  username: "",
  password: "",
  user: null,
  columnDefs: [],
  sampleTypes: [],
  elabUserFailed: false,
  log: [],
  storageLocations: [],
  storageLocation: null,

  isFetchingLogin: false,
  isFetchingSampleTypes: false,
  isFetchingStorageLocations: false
};

const elabUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ELAB_USER:
      return {
        ...state,
        elabUser: action.payload,
        isFetchingLogin: false,
        elabUserFailed: false
      };
    case types.SET_ELAB_USER_FAILED:
      return {
        ...state,
        elabUser: {},
        isFetchingLogin: false,
        elabUserFailed: true
      };
    case types.SET_STORAGE_LOCATIONS:
      return {
        ...state,
        storageLocations: action.payload,
        isFetchingStorageLocations: false
      };
    case types.SET_SAMPLE_TYPES:
      return {
        ...state,
        sampleTypes: action.payload,
        isFetchingSampleTypes: false
      };
    case types.SET_SAMPLE_TYPE:
      return { ...state, sampleType: action.payload };
    case types.SET_COL_DEFS:
      return { ...state, columnDefs: action.payload };
    case types.SET_USERNAME:
      return { ...state, username: action.payload };
    case types.SET_PASSWORD:
      return { ...state, password: action.payload };
    case types.TOGGLE:
      return { ...state, [action.payload]: !state[action.payload] };
    default:
      return state;
  }
};

export default elabUploadReducer;
